export default {"src":"/_next/static/media/Thether.9d4d3de6.svg","height":73,"width":74};